var _path, _path2, _rect, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgr3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5143 74.332C70.8493 75.7345 79.3664 80.2226 78.7544 86.9547C78.3312 91.6102 76.4445 94.4511 73.4507 94.2144C75.3929 94.6167 77.6701 94.5867 80.2845 93.8397C88.8525 91.3917 102.725 87.2097 108.59 85.4247C114.2 85.2972 123.278 87.4902 114.71 97.2823L78.7544 108.375C72.8894 110.542 60.5472 111.358 58.0992 97.2823L45.4766 100.725V77.7746L46.6241 77.5868L66.5143 74.332Z",
    fill: "#DFC8C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 94C71 93.5 64.5 93 62.7344 86.4746",
    stroke: "#676666",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 67.0645,
    width: 13.0051,
    height: 42.0755,
    rx: 6.50257,
    fill: "#65765E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4743 47.3084V67.918C88.3162 66.1102 80 62.7107 80 52.7313C80 42.7518 90.3048 41.8853 92.4743 47.3084Z",
    fill: "#6C9D54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.471 47.3084V67.918C96.6291 66.1102 104.945 62.7107 104.945 52.7313C104.945 42.7518 94.6405 41.8853 92.471 47.3084Z",
    fill: "#6C9D54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgr3);
export default __webpack_public_path__ + "static/media/agr-3.8cb2efc319b21ca04f81e98926884dc8.svg";
export { ForwardRef as ReactComponent };